var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.71,6.74,17.26.29,16.56,0H7.44l-.7.29L.29,6.74,0,7.44v9.12l.29.7,6.45,6.45.7.29h9.12l.7-.29,6.45-6.45.29-.7V7.44ZM7.86,22,2,16.14V7.86L7.86,2h3.41V4H9.1l-.71.29-4.1,4.1L4,9.1v5.8l.29.71,4.1,4.1L9.1,20h5.8l.71-.29,4.1-4.1L20,14.9V13.73h2v2.41L16.14,22ZM18,14.49,14.49,18h-5L6,14.49v-5L9.51,6h5L18,9.51Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReport);
export default __webpack_public_path__ + "static/1787897133/media/icon-report.06de8d43726bfe038e5292ca2fda1153.svg";
export { ForwardRef as ReactComponent };